import { sso } from '../en';

export const ssoAR: typeof sso = {
  title: `لم نتمكن من تسجيل دخولك...`,
  text: `لقد واجهنا خطأ. نعتذر عن الإزعاج. يرجى محاولة تسجيل الدخول مرة أخرى عبر صفحة المشرق الخاصة بك`,
  url: 'https://www.mashreqbank.com/en/uae/personal/',
  button: 'الرحوع الي مشرق',
};
